import React from "react"
import { useAdertisementData } from "./utils"

export const LeaderboardTop = ({ adbutler_page_id, ressort, tags, topic }) => {
  // Client-side Runtime Data Fetching
  const adbutlerIds = {
    baumagazin: 606966,
    galabau: 606971,
    umweltbau: 606978,
  }

  const state = useAdertisementData({
    adbutler_page_id: adbutler_page_id,
    set_id: adbutlerIds[ressort],
    min_width: 1215,
    tags,
    ressort,
    topic,
  })

  return (
    <div className="is-hidden-until-widescreen">
      <div
        data-nosnippet
        className="my-2 is-flex"
        style={{
          minHeight:
            typeof window !== "undefined" && window?.innerWidth <= 1215
              ? 0
              : "100px",
        }}
      >
        {state.body ? (
          <div className="my-auto has-text-centered" style={{ width: "100%" }}>
            <div
              dangerouslySetInnerHTML={{ __html: state.body }}
              className="mt-1 leaderboard-ad"
            ></div>
          </div>
        ) : state.imageURL ? (
          <div className="my-auto has-text-centered" style={{ width: "100%" }}>
            <a
              href={state.redirectURL}
              target={state.link_target}
              rel="noopener noreferrer"
              title={`Anzeige`}
              className="leaderboard-ad"
            >
              <img
                src={state.imageURL}
                title={`Anzeige`}
                alt={`Anzeige`}
                width={state.imageWidth || "auto"}
                height={state.imageHeight || "auto"}
                style={{ maxWidth: "970px" }}
              />
            </a>
          </div>
        ) : null}
        {!!state?.tracking_pixel ? (
          <img
            alt=""
            src={state?.tracking_pixel}
            border="0"
            width="1"
            height="1"
          />
        ) : null}
      </div>
    </div>
  )
}
